<template>
  <div class="Kanit BGwhite">
    <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important;  color: rgb(74, 74, 74) !important;">
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center;    margin-top: -4vh;">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xl12 md12 sm12 lg12></v-flex>
                <v-flex sm10 md10 lg10 xl10 v-if="bottotal.length != 0">
                  <v-layout align-left justify-left column>
                    <h3 slot="header" class="Kanit">รายชื่อ บอท ({{bottotal.length}})</h3>
                  </v-layout>
                </v-flex>
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs12 sm3 md3 xl4 lg4>
                      <div class="listbotcard" @click="gotoLink('/develop/createbot')">
                        <v-layout align-center justify-space-around wrap>
                          <i class="fas fa-plus fa-5x iconplus"></i>
                        </v-layout>
                        <div class="text-name-status">
                          <h4 class="namebot">สร้างบอท</h4>
                          <p class="statusbot">ต้องการสร้างบอท เลือกเลย</p>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm3 md3 xl4 lg4 v-for="(item, index) in bottotal" :key="index" v-if="bottotal.length != 0">
                      <div class="cardticket" @click="routeProfile(item)">
                        <div class="cardticket-header">
                          <v-img class="image" :src="item.profilepicture? item.profilepicture:'../../../static/img/robot/robot1.png'"></v-img>
                          <h4 class="header-text">{{splitNickname(item.nickname)}}</h4>
                        </div>
                        <div class="cardticket-body">
                          <span class="statusbot whenhoverstable">&nbsp;&nbsp;&nbsp;&nbsp;{{(item.status !== '')? splitStatus(item.status):'-'}}</span>
                          <vue-typed-js class="statusbot whenhovertyping" :showCursor="true" :loop="true" :typeSpeed="50" :backSpeed="50" :strings="[(item.status !== '')? '&nbsp;&nbsp;&nbsp;&nbsp;'+splitStatus(item.status):'&nbsp;&nbsp;&nbsp;&nbsp;-']">
                            <span class="typing statusbot"></span>
                          </vue-typed-js>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-layout>
            </v-container>
          </v-flex>
          <br>
        </v-layout>
      </v-container>
    </v-card-text>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'
// import $ from 'jquery'

Vue.component(VueQrcode.name, VueQrcode)
export default {
  data: () => ({
    development: '',
    token: '',
    name: '',
    status: '',
    TypeSearch: '',
    search: '',
    NewArray: [], // เอาไว้รับค่าที่ socket ส่งมาเพื่อเก็บไว้
    ArrayList: [], // เอาไว้เก็บข้อมูลเพื่อทำการ push เก็บรอการส่งเข้า global variable
    tokenFriend: '',
    filename: '',
    webbackend: '',
    botid: '',
    botiderror: '',
    botidstatus: false,
    botname: '',
    detail: '',
    webhook: '',
    msg_reply: '',
    usernameRules: [
      v => (!!v && v.length >= 6) || 'กรุณาใส่ตัวอักษรอย่างน้อย 6 ตัว',
      v => /^([a-z0-9])+$/.test(v) || 'กรุณาใส่ชื่อผู้ใช้งานเป็นภาษาอังกฤษ a-z และ 0-9 เท่านั้น',
      v => /[^\W_]+$/.test(v) || 'ไม่สามารถใช้อักขระพิเศษได้'
    ],
    bottotal: [],
    windowWidth: '',
    progress: false
  }),
  methods: {
    gotoLink (link) {
      if (link === 'logout') {
        this.logout()
      } else {
        this.$router.push(link)
      }
    },
    routeProfile (data) {
      if (data === undefined) {
        this.$router.push('/develop/homepage')
        this.$store.dispatch('tokenRoom', 'noneselect')
        this.$store.dispatch('changeRightTool', 'Friend')
        this.$cookies.set('tokenRoom', 'noneselect')
        localStorage.setItem('room', 'noneselect')
        this.$store.dispatch('changeBot', 'noneselect')
      } else {
        this.$store.dispatch('tokenRoom', data.bot_id)
        this.$store.dispatch('changeBot', data)
        localStorage.setItem('room', data.bot_id)
        this.actionF = data.bot_id
        this.$store.dispatch('changeRightTool', 'Friend')
        this.$cookies.set('tokenRoom', data.bot_id)
        this.$router.push('/develop/homepage/' + data.bot_id + '/' + data.tokenuser)
      }
    },
    updatename () {
      this.editname = !this.editname
      this.$http.post(process.env.APImanage + '/setnameuser', {tokenuser: this.token, name: this.nameedit}).then((response) => {
        if (response.body['status'] === 'success') {
          this.$store.dispatch('myProfile', 'name ' + this.nameedit)
          localStorage.setItem('name', this.nameedit)
          this.name = this.nameedit
        }
      }, (response) => {})
    },
    updatestatus () {
      this.editdescription = !this.editdescription
      this.$http.post(process.env.APImanage + '/setstatususer', {tokenuser: this.token, status: this.statusedit}).then((response) => {
        if (response.body['status'] === 'success') {
          this.$store.dispatch('myProfile', 'status ' + this.statusedit)
          localStorage.setItem('status', this.statusedit)
          this.status = this.statusedit
        }
      }, (response) => {})
    },
    clearinfo () {
      this.botid = ''
      this.botname = ''
      this.detail = ''
      this.webhook = ''
      this.msg_reply = ''
      this.botiderror = ''
      this.botidstatus = false
    },
    checkID () {
      if (this.botid !== '') {
        this.$http.post(process.env.APImanage + '/checkbotid', {bot_id: this.botid}).then((response) => {
          if (response.body['status'] === 'success') {
            this.botiderror = ''
            this.botidstatus = true
          } else if (response.body['status'] === 'fail' && response.body['message'] === 'id duplicate') {
            this.botiderror = 'ไอดีนี้ถูกใช้ไปแล้ว'
            this.botidstatus = false
          }
        }, (response) => {})
      }
    },
    submit () {
      this.$http.post(process.env.APImanage + '/createbot', {token_owner: this.token, bot_id: this.botid, bot_name: this.botname, detail: this.detail, webhook: this.webhook, message_defult: this.msg_reply}).then((response) => {
        // console.log(response.body)
        if (response.body['status'] === 'success') {
          this.clearinfo()
          this.$swal(
            'Success!',
            'Bot ถูกสร้างแล้ว',
            'success'
          )
          this.$store.dispatch('listFriend', 'addbot' + response.body['tokenBot'])
          // console.log(response.body)
        }
      }, (response) => {})
    },
    getlistbot () {
      this.progress = true
      this.$http.post(process.env.APImanage + '/web/getlistbot', {tokenuser: this.token}).then((response) => {
        if (response.body['message'] === 'success') {
          this.progress = false
          this.bottotal = response.body['listbot']
        }
      })
    },
    splitNickname (name) {
      if (name.length > 13) {
        name = name.substring(0, 13)
        name = name + '...'
        return name
      } else {
        return name
      }
    },
    splitStatus (status) {
      if (status.length > 16) {
        status = status.substring(0, 16)
        status = status + '...'
        return status
      } else {
        return status
      }
    }
  },
  computed: {
    ...mapState({
      myprofile: 'myprofile'
    })
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
    // this.splitNickname()
    // this.splitStatus()
  },
  watch: {
    windowWidth () {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/develop/homepage')
      }
    },
    myprofile () {
      console.log('myProfile')
      this.filename = localStorage.getItem('profilepicture')
    },
    botid () {
      if (this.botid === '') {
        this.botidstatus = false
      }
      if (this.botidstatus && this.botid !== '') {
        this.checkID()
      }
    }
  },
  created () {
    // this.phone = localStorage.getItem('phone')
    // this.email = localStorage.getItem('email')
    this.token = localStorage.getItem('tokenuser')
    this.getlistbot()
    // this.name = localStorage.getItem('name')
    // this.status = localStorage.getItem('status')
    // this.webbackend = process.env.API
    // this.filename = localStorage.getItem('profilepicture')
    // this.development = '-'
    // this.tokenservice = localStorage.getItem('tokenservice')
    // this.tokenuserQR = 'https://com.oneplatform.android.onechat/u/' + btoa(localStorage.getItem('email'))
    // this.nameedit = this.name
    // this.statusedit = this.status
  }
}
</script>
<style type="text/css" scoped>

.Kanit {
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}


.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}



.List_Register {
  margin-bottom: 32px;
  box-sizing: border-box;
}

.List_Register .List_item:last-child {
  border-bottom: none;
}

.List_Register .List_item {
  display: -webkit-flex;
  display: flex;
  padding: 0;
}

.List_Register .List_item:last-child .List_item_header {
  width: 200px;
}





.BreakWord {
  white-space: pre-wrap;
  word-break: break-all;
  word-break: break-word;
  word-wrap: break-word;
}



.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.BGwhite {
  background-color: white !important;
}

.text-name-status {
  padding-top: 0px;
  margin-top: 5px;
  /*margin-bottom: 2px;*/
  text-align: center;
}



.flex.md3 {
  flex-basis: 25%;
  flex-grow: 0;
  max-width: 25%;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  /* background: #1b232d; */
  background: rgba(230, 230, 230, 0.2);
}

::-webkit-scrollbar-thumb {
  background: #888;
}

.image {
  /*opacity: 0.8;*/
  border: 1px solid #2463af;
  border-radius: 10px;
  object-fit: cover;
  object-position: 50% 0;
  height: 130px;
  width: 130px;
}

.listbotcard {
  padding: 10px;
  /*margin-right: 18px;*/
  cursor: pointer;
  margin: 10px;
}

.listbotcard:hover {
  background: #2463af;
  border-radius: 10px;
}

.listbotcard:hover .image {
  border: none;
}

.text-name-status .namebot {
  color: #2463af;
  font-size: 16px;
}

.text-name-status .statusbot {
  color: grey;
  font-size: 14px;
}
.text-name-status .whenhover {
  color: grey;
  font-size: 14px;
  display: none;
}



.listbotcard:hover .text-name-status .namebot {
  color: white;
}

.listbotcard:hover .text-name-status .statusbot {
  color: white;
}

.listbotcard .iconplus {
  color: #2463af;
  display: block;
  padding-top: 20px;
  font-size: 100px;
  height: 130px;
}

.listbotcard:hover .iconplus {
  color: white;
  display: block;
}

.cardticket {
  width: 205px;
  border-radius: 10px;
  margin: 10px;
  background: white;
  overflow: hidden;
  cursor: pointer;
}

.cardticket-header .header-text {
  color: #2463af;
}

.cardticket:hover .cardticket-header .header-text {
  color: white;
}

.cardticket:hover {
  background: #2463af;
  color: white;
}

.cardticket:hover .cardticket-header {
  border-bottom: 2px dotted white;
}

.cardticket-header {
  height: 175px;
  border: 2px solid #2463af;
  border-bottom: 2px dotted #2463af;
  border-radius: 10px 10px 0 0;
  position: relative;
  text-align: center;
  padding: 10px;
  display: grid;
  justify-content: center;
}

.cardticket-header:before,
.cardticket-header:after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 100%;
  bottom: -12px;
  border: 2px solid #2463af;
  box-sizing: border-box;
}

.cardticket-header:before {
  left: -10px;
}

.cardticket-header:after {
  right: -10px;
}

.cardticket-body {
  height: 50px;
  border: 2px solid #2463af;
  border-top: none;
  border-radius: 0 0 10px 10px;
  padding: 10px;
}
.cardticket-body .whenhovertyping{
  display: none;
}
.cardticket:hover .whenhovertyping {
  display: initial;
}
.cardticket:hover .whenhoverstable {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/managebot/listbot.vue